import { render, staticRenderFns } from "./ReaderAttributeFilters.vue?vue&type=template&id=cefa9986&"
import script from "./ReaderAttributeFilters.vue?vue&type=script&lang=js&"
export * from "./ReaderAttributeFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports